import httpClient from "../httpClient";
import { API_CASE_BOOKMARK } from "../config";

const bookmarkCase = {
    bookmark: (id, data) => httpClient.post(API_CASE_BOOKMARK + '/' + id, data),
};

export default bookmarkCase;